var map = {
	"./ActionTake/index.js": 1619,
	"./Actions/index.js": 1620,
	"./FooterContext/index.js": 1621,
	"./FrontDetect/index.js": 1622,
	"./FrontIntroduction/index.js": 1623,
	"./FrontJourney/index.js": 1624,
	"./FrontNavigateTheWorld/index.js": 1625,
	"./FrontPrograms/index.js": 1626,
	"./FrontTrustTheBlockchain/index.js": 1627,
	"./FrontTrustTheTrustless/index.js": 1628,
	"./FrontWebRTC/index.js": 1629
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3324;


//////////////////
// WEBPACK FOOTER
// ./src/interface/workshop/sections \.\/.+\/index\.js$
// module id = 3324
// module chunks = 0